import { ListingType } from '../../__generated__/fed-graphql-types'
import {
    SearchResultsListingsGridQuery_searchResults_SearchResults_listings,
    SearchResultsListingsGridQuery_searchResults_SearchResults_listings_LeasingListing,
    SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing,
} from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'

const isListingWithPageNumber = (
    listing: SearchResultsListingsGridQuery_searchResults_SearchResults_listings
): listing is
    | SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing
    | SearchResultsListingsGridQuery_searchResults_SearchResults_listings_LeasingListing =>
    listing.type === ListingType.NATURAL_LISTING ||
    listing.type === ListingType.PROMOTED_LISTING ||
    listing.type === ListingType.LEASING_LISTING ||
    listing.type === ListingType.DEALER_STOCK_LISTING

export const getPageNumbersFromListings = (
    listings: ReadonlyArray<SearchResultsListingsGridQuery_searchResults_SearchResults_listings> = []
) =>
    listings
        ?.filter(
            (
                listing
            ): listing is
                | SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing
                | SearchResultsListingsGridQuery_searchResults_SearchResults_listings_LeasingListing =>
                isListingWithPageNumber(listing) && !!listing?.trackingContext.card.pageNumber
        )
        ?.map((listing) => listing.trackingContext.card.pageNumber) || []
